import { trainingConstants } from "../constants/training.constant";

let initialState = {
    trainingList : [],
    myTraining : [],
    teamTrainingList : [],
    trainingDetails : [],
    ongoingTrainings : [],
    externalTrainingList : [],
    allExternalTrainings : [],
    error : ""
}

export const fetchTrainingList_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.TRAINING_LIST_SUCCESS :
            return {
                ...state,
                trainingList : action.payload.data,
            }

        case trainingConstants.TRAINING_LIST_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}

export const fetchMyTraining_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.MY_TRAINING_SUCCESS :
            return {
                ...state,
                myTraining : action.payload.data,
            }

        case trainingConstants.MY_TRAINING_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}

export const fetchTeamTraining_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.TEAM_TRAINING_SUCCESS :
            return {
                ...state,
                teamTrainingList : action.payload.data,
            }

        case trainingConstants.TEAM_TRAINING_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}

export const fetchTrainingDetails_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.TRAINING_DETAILS_SUCCESS :
            return {
                ...state,
                trainingDetails : action.payload.data,
            }

        case trainingConstants.TRAINING_DETAILS_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}


export const fetchOngoingTraining_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.ONGOING_TRAINING_SUCCESS :
            return {
                ...state,
                ongoingTrainings : action.payload.data,
            }

        case trainingConstants.ONGOING_TRAINING_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}

export const fetchExternalTrainingList_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.EXTERNAL_TRAINING_LIST_SUCCESS :
            return {
                ...state,
                externalTrainingList : action.payload.data,
            }

        case trainingConstants.EXTERNAL_TRAINING_LIST_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}

export const fetchAllExternalTraining_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case trainingConstants.ALL_EXTERNAL_TRAINING_SUCCESS :
            return {
                ...state,
                allExternalTrainings : action.payload.data,
            }

        case trainingConstants.ALL_EXTERNAL_TRAINING_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}